import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Container, Label, ErrorText } from './components/AutoCompleteStyles';
import { useAutoCompleteSelect } from './hooks/useAutoCompleteSelect';
import { buildCustomStyles } from './utils/autoCompleteHelpers';

const AutoCompleteSelect = ({
  options,
  value,
  onChange,
  disabled,
  placeholder,
  label,
  error,
  size,
  isClearable,
  isSearchable,
  onInputChange,
}) => {
  const { formattedOptions, selectedOption, handleChange } = useAutoCompleteSelect({
    options,
    value,
    onChange,
  });

  const customStyles = buildCustomStyles({ disabled, error, size });

  return (
    <Container>
      {label && <Label disabled={disabled}>{label}</Label>}
      <Select
        isDisabled={disabled}
        options={formattedOptions}
        value={selectedOption}
        onChange={handleChange}
        onInputChange={onInputChange}
        placeholder={placeholder}
        styles={customStyles}
        isClearable={isClearable}
        isSearchable={isSearchable}
        noOptionsMessage={() => 'Nenhuma opção encontrada'}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
};

AutoCompleteSelect.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        label: PropTypes.string.isRequired,
      }),
    ])
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
};

AutoCompleteSelect.defaultProps = {
  size: 'sm',
  disabled: false,
  value: undefined,
  onChange: undefined,
  label: undefined,
  error: undefined,
  placeholder: 'Selecione ou digite...',
  isClearable: true,
  isSearchable: true,
};

export default AutoCompleteSelect;



// WEBPACK FOOTER //
// ./src/design-system/atoms/AutoCompleteSelect/AutoCompleteSelect.jsx